export enum TipoRodadaEnum {
  DIVIDA = 'DIVIDA',
  EQUITY = 'EQUITY',
}
